import React from 'react'
import moment from 'moment'
import { withRouter } from 'react-router-dom'
import { Switch, Tag, Menu} from 'antd'
import UserAvatar from '../../Shared/UserAvatar/index'
import './index.scss'

export const colorByRole = {
  Admin: '#FF7771',
  Owner: '#464B51',
  User: '#82D8F2'
}

export default withRouter(({ user = {role:{}}, auth = {user:{role:{}}}, history, toggleUserActive }) => (
  <div
    className='user-card round-corner'
    onClick={() => history.push('/users/' + user.id)}>
    <div className='avatar'>
      <UserAvatar user={user} style={{ width: '70px', lineHeight: '77px' }} />
    </div>
    <div className='info'>
      <p className='name'>
        {user.first_name + ' ' + user.last_name}
      </p>
      <p className='activation-date'>
        Active since {' '}
        {moment(user.created_at).format('MM/DD/YYYY')}
      </p>
      <p className='email'>{user.email}</p>
    </div>
    <div className='actions'>
      <div>
        <Tag color={colorByRole[user.role.title]}>
          {user.role.title}
        </Tag>
        {/*<Dropdown overlay={actionMenu}>
          <a className='ant-dropdown-link' href='#'>
            <Icon type='ellipsis' />
          </a>
        </Dropdown>*/}
      </div>
      {
        (auth.user.id !== user.id && (auth.user.role.title === 'Owner' || (auth.user.role.title === 'Admin' && user.role.title === 'User'))) ?
          <div onClick={e => e.stopPropagation()}>
            <Switch
              checked={user.active}
              onChange={toggleUserActive.bind(null, user.id)}/>
            <span>Active</span>
          </div> : null
      }
    </div>
  </div>
))

const actionMenu = (
  <Menu>
    <Menu.Item>
      <a target='_blank' rel='noopener noreferrer' href='http://www.alipay.com/'>action 1</a>
    </Menu.Item>
    <Menu.Item>
      <a target='_blank' rel='noopener noreferrer' href='http://www.taobao.com/'>action 2</a>
    </Menu.Item>
    <Menu.Item>
      <a target='_blank' rel='noopener noreferrer' href='http://www.tmall.com/'>action 3</a>
    </Menu.Item>
  </Menu>
)
